<template>
  <v-container text-xs-center>
    <v-toolbar color="white" flat>
      <v-layout row align-center justify-space-between>
        <template v-for="(link, index) in links">
          <v-flex :key="link + index" xs4 sm4 md4>
            <v-btn :to="{ name: link.to }" :key="link.id" active-class="accent--text" flat round>{{ link.name }}</v-btn>
          </v-flex>
          <span :key="index" v-if="index !== (links.length - 1)">/</span>
        </template>
      </v-layout>
    </v-toolbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          id: "hot",
          name: "急上昇",
          to: "Hot"
        },
        {
          id: "new",
          name: "新着",
          to: "New"
        },
        {
          id: "friends",
          name: "友達",
          to: "Friends"
        }
      ]
    };
  }
};
</script>